import * as React from 'react';

import AddressModalGraphicSvg from './address-modal-graphic.svg';

import styles from './onboarding-modal-graphic-styles.module.css';

export class AddressModalGraphic extends React.PureComponent<Record<any, any>> {
    render() {
        return (
            <div className={styles.container}>
                <AddressModalGraphicSvg />
            </div>
        );
    }
}
